import { useMutation } from "urql";

import { CreateDeskCollectionDocument } from "../../../../graphql/generated.ts";

export function useCreateDeskCollection() {
  return useMutation(CreateDeskCollectionDocument);
}
